import { SITE_ID } from "../../extensions/gamemode_management/constants";
import { activeGameId } from "../../util/selectors";
import { getSafe } from "../../util/storeHelper";
import { SITE_GAME_NAME } from "../constants";
import * as React from "react";
import { connect } from "react-redux";
import Select from "react-select";
function compare(lhs, rhs, discovered) {
    const lPath = getSafe(discovered, [lhs.id, "path"], undefined);
    const rPath = getSafe(discovered, [rhs.id, "path"], undefined);
    if ((lPath === undefined) === (rPath === undefined)) {
        return (lhs.shortName || lhs.name).localeCompare(rhs.shortName || rhs.name);
    }
    else {
        return lPath !== undefined ? -1 : 1;
    }
}
export class GameFilterComponent extends React.Component {
    render() {
        const { t, discovered, filter, games } = this.props;
        const translate = (gameName) => gameName
            .split("\t")
            .map((part) => t(part))
            .join(" ");
        const options = [
            {
                label: `<${t("Current Game")}>`,
                value: "$",
            },
        ].concat(games
            .slice()
            .concat({
            id: SITE_ID,
            shortName: t(SITE_GAME_NAME),
            name: t(SITE_GAME_NAME),
            extensionPath: null,
            requiredFiles: null,
            executable: null,
        })
            .sort((lhs, rhs) => compare(lhs, rhs, discovered))
            .map((game) => ({
            label: game.shortName || translate(game.name),
            value: game.id,
        })));
        return (React.createElement(Select, { className: "select-compact", options: options, value: filter, onChange: this.changeFilter, autosize: false, placeholder: t("Select...") }));
    }
    changeFilter = (value) => {
        const { attributeId, onSetFilter } = this.props;
        onSetFilter(attributeId, value !== null ? value.value : null);
    };
}
function mapStateToProps(state) {
    return {
        discovered: state.settings.gameMode.discovered,
        games: state.session.gameMode.known,
    };
}
const FilterConn = connect(mapStateToProps)(GameFilterComponent);
class GameFilter {
    component = FilterConn;
    raw = false;
    matches(filter, value, state) {
        return filter === "$"
            ? value.indexOf(activeGameId(state)) !== -1
            : value.indexOf(filter) !== -1;
    }
}
export default GameFilter;
